import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TachoFileAnalysis = _resolveComponent("TachoFileAnalysis")!

  return (_openBlock(), _createBlock(_component_TachoFileAnalysis, {
    "detail-only": true,
    "driver-id": _ctx.driverId
  }, null, 8, ["driver-id"]))
}